import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/layout/Layout";
import FeatureFlagsBootstrap from "@/components/FeatureFlagsBootstrap";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Entreprises from "@/pages/Entreprises";
import Salaries from "@/pages/Salaries";
import Conventions from "@/pages/Conventions";
import Missions from "@/pages/Missions";
import Timesheets from "@/pages/Timesheets";
import Absences from "@/pages/Absences";
import Frais from "@/pages/Frais";
import Credits from "@/pages/Credits";
import AppelsContribution from "@/pages/AppelsContribution";
import GED from "@/pages/GED";
import Assistant from "@/pages/Assistant";
import AuditLogs from "@/pages/AuditLogs";
import Demandes from "@/pages/Demandes";
import Medical from "@/pages/Medical";
import Comptabilite from "@/pages/Comptabilite";
import Verify from "@/pages/Verify";
import QrScans from "@/pages/QrScans";
import NotesTerrain from "@/pages/NotesTerrain";
import EmailDashboard from "@/pages/EmailDashboard";
import RegistreMembres from "@/pages/RegistreMembres";
import RegistreSalaries from "@/pages/RegistreSalaries";
import Roles from "@/pages/Roles";
import Tasks from "@/pages/Tasks";
import Aujourdhui from "@/pages/Aujourdhui";
import PreparationPaie from "@/pages/PreparationPaie";
import CleanupManifest from "@/pages/CleanupManifest";
import FeatureFlagsAdmin from "@/pages/FeatureFlagsAdmin";
import AdminUsers from "@/pages/AdminUsers";
import Prospects from "@/pages/Prospects";
import CourrielsAdmin from "@/pages/CourrielsAdmin";
import Lili from "@/pages/Lili";
import Conformite from "@/pages/Conformite";
import RoleGuard from "@/components/RoleGuard";
import Contrats from "@/pages/Contrats";
import Devis from "@/pages/Devis";
import Invitation from "@/pages/Invitation";
import MemoireZoe from "@/pages/MemoireZoe";
import Planning from "@/pages/Planning";
import ExportProfiles from "@/pages/ExportProfiles";
import { isFeatureEnabled } from "@/lib/featureFlags";

function App() {
  const [flagsVersion, setFlagsVersion] = useState(0);
  return (
    <div className="App notranslate" translate="no">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <FeatureFlagsBootstrap onVersionChange={setFlagsVersion} />
          <Routes key={`fv-${flagsVersion}`}>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/invitation/:token" element={<Invitation />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify/:docType/:docId" element={<Verify />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              {isFeatureEnabled("lot3_aujourdhui") && (
                <Route path="aujourdhui" element={<Aujourdhui />} />
              )}
              <Route path="entreprises" element={<Entreprises />} />
              <Route path="salaries" element={<Salaries />} />
              <Route path="conventions" element={<Conventions />} />
              <Route path="missions" element={<Missions />} />
              <Route path="planning" element={<Planning />} />
              <Route path="timesheets" element={<Timesheets />} />
              <Route path="absences" element={<Absences />} />
              <Route path="frais" element={<Frais />} />
              <Route path="credits" element={<Credits />} />
              <Route path="appels" element={<AppelsContribution />} />
              <Route path="comptabilite" element={<Comptabilite />} />
              {isFeatureEnabled("lot4_preparation_paie") && (
                <Route path="preparation-paie" element={<PreparationPaie />} />
              )}
              <Route path="export-profiles" element={<ExportProfiles />} />
              <Route path="demandes" element={<Demandes />} />
              <Route path="medical" element={<Medical />} />
              <Route path="qr-scans" element={<QrScans />} />
              <Route path="ged" element={<GED />} />
              <Route path="assistant" element={<Assistant />} />
              <Route path="notes" element={<NotesTerrain />} />
              <Route path="emails" element={<EmailDashboard />} />
              <Route path="registre-membres" element={<RegistreMembres />} />
              <Route path="registre-salaries" element={<RegistreSalaries />} />
              <Route path="taches" element={<Tasks />} />
              <Route path="zoe-memoire" element={<MemoireZoe />} />
              <Route path="contrats" element={<RoleGuard roles={["admin", "gestionnaire_ge", "auditeur", "salarie"]}><Contrats /></RoleGuard>} />
              <Route path="devis" element={<RoleGuard roles={["admin", "gestionnaire_ge", "finance", "auditeur"]}><Devis /></RoleGuard>} />
              <Route path="roles" element={<Roles />} />
              <Route path="audit" element={<AuditLogs />} />
              <Route path="cleanup-manifest" element={<CleanupManifest />} />
              <Route path="admin/feature-flags" element={<FeatureFlagsAdmin />} />
              <Route path="admin/comptes" element={<AdminUsers />} />
              <Route path="prospects" element={<Prospects />} />
              <Route path="admin/courriels" element={<CourrielsAdmin />} />
              <Route path="lili" element={<Lili />} />
              <Route path="conformite" element={<RoleGuard roles={["admin", "gestionnaire_ge", "auditeur"]}><Conformite /></RoleGuard>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
